<template>
  <q-card
    flat
    square
  >
    <div class="q-pa-md text-body2">
      <div class="row items-center q-gutter-md">
        <div class="col-auto">
          <slot name="icon">
            <q-icon
              :name="mdiAlert"
              color="yellow"
              size="sm"
            />
          </slot>
        </div>
        <div class="col content">
          <slot name="content">
            WARNING: This product contains chemicals known to the State of
            California to cause cancer, birth defects, or other reproductive
            harm. For more information, go to
            <a
              href="https://www.p65warnings.ca.gov"
              class="text-link text-weight-medium"
              target="_blank"
              rel="noopener noreferrer"
            >www.p65warnings.ca.gov</a>.
          </slot>
        </div>
      </div>
    </div>
  </q-card>
</template>

<script lang="ts" setup>
import { mdiAlert } from '@quasar/extras/mdi-v7';
</script>

<style lang="scss" scoped>
@use "sass:map";

.content {
  @media (min-width: $breakpoint-md-min) {
    font-size: map.get($body1, 'size');
    font-weight: map.get($body1, 'weight');
    line-height: map.get($body1, 'line-height');
    letter-spacing: map.get($body1, 'letter-spacing');
  }
}
</style>
